<template>
  <transition name="slide-and-back-bottom">
    <div class="gdpr-prompt" v-if="isPromptVisible">
      <p class="text-light">
        {{ $t('gdpr-1') }}
        <router-link class="text-light" to="/sustainability?page=gdpr">{{ $t('gdpr-2') }}</router-link>
      </p>
      <div class="text-group">
        <a @click="accept" class="link">
          <span class="text-light">{{ $t('gdpr-3') }}</span>
        </a>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      isPromptVisible: false
    };
  },
  methods: {
    accept() {
      localStorage.setItem("termsAccepted", true);
      this.isPromptVisible = false;
    }
  },
  mounted() {
    const accepted = localStorage.getItem("termsAccepted");
    setTimeout(() => {
      if (accepted) {
        this.isPromptVisible = false;
      } else {
        this.isPromptVisible = true;
      }
    }, 5000);
  }
};
</script>

<style lang="scss" scoped>
.gdpr-prompt {
  align-items: center;
  background-color: $mainColor95;
  bottom: 0;
  display: flex;
  justify-content: space-between;
  left: 0;
  padding: 15px 25px;
  position: fixed;
  width: 100%;
  z-index: 10;
  p {
    font-size: 16px;
    width: 40%;
    a {
      text-decoration: underline;
    }
    a:hover {
      opacity: 0.8;
    }
  }
  .text-group {
    margin-bottom: -10px;
  }
}
@media screen and (max-width: 1280px) {
  .gdpr-prompt {
    p {
      font-size: 14px;
      line-height: 16px;
      width: 50%;
    }
  }
}
@media screen and (max-width: 1000px) {
  .gdpr-prompt {
    p {
      width: 65%;
    }
  }
}
@media screen and (max-width: 600px) {
  .gdpr-prompt {
    p {
      font-size: 12px;
      line-height: 14px;
    }
  }
}
@media screen and (max-width: 420px) {
  .gdpr-prompt {
    flex-direction: column;
    padding-bottom: 30px;
    p {
      margin-bottom: 10px;
      text-align: center;
      width: 100%;
    }
  }
}
</style>
